import { z } from 'zod';

/**
 * Denomination form validation, mirroring the Admin API
 * (AdminDenominationRequest). Input type === output type: numbers are
 * converted at the input, '' becomes null at submit.
 */
export const denominationSchema = z.object({
  name: z.string().trim().min(1, 'Name is required.').max(100, 'Must be 100 characters or fewer.'),
  arName: z.string().trim().max(100, 'Must be 100 characters or fewer.'),
  regionId: z.number({ message: 'Select a region.' }).int().positive('Select a region.'),
  currencyCode: z
    .string()
    .trim()
    .regex(/^[A-Z]{3}$/, 'Use a three-letter currency code, e.g. USD.'),
  imageUrl: z
    .string()
    .trim()
    .max(500, 'Must be 500 characters or fewer.')
    .refine((value) => value === '' || z.url().safeParse(value).success, 'Enter a valid URL.'),
  /** Used on create only; status changes through its own confirmed action. */
  isActive: z.boolean(),
});

export type DenominationFormValues = z.infer<typeof denominationSchema>;
